import { render, staticRenderFns } from "./bdd-checklists.vue?vue&type=template&id=68656311&scoped=true"
import script from "./bdd-checklists.vue?vue&type=script&lang=js"
export * from "./bdd-checklists.vue?vue&type=script&lang=js"
import style0 from "./bdd-checklists.vue?vue&type=style&index=0&id=68656311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68656311",
  null
  
)

export default component.exports